import type { MouseEvent, ReactNode } from "react";
import { Link } from "react-router-dom";
import styles from "./NavItem.module.css";

export interface NavItemProps {
  to: string;
  label: string;
  icon?: ReactNode;
  badge?: number | ReactNode;
  active?: boolean;
  onClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
  "data-testid"?: string;
  badgeTestId?: string;
}

export function NavItem({
  to,
  label,
  icon,
  badge,
  active,
  onClick,
  badgeTestId,
  "data-testid": testId,
}: NavItemProps) {
  const showBadge =
    badge !== undefined &&
    badge !== null &&
    badge !== false &&
    badge !== 0 &&
    badge !== "";
  const className = active ? `${styles.item} ${styles.active}` : styles.item;
  return (
    <Link
      to={to}
      className={className}
      data-testid={testId}
      data-active={active ? "true" : undefined}
      onClick={onClick}
    >
      {icon ? <span className={styles.icon}>{icon}</span> : null}
      <span className={styles.label}>{label}</span>
      {showBadge ? (
        <span className={styles.badge} data-testid={badgeTestId}>
          {badge}
        </span>
      ) : null}
    </Link>
  );
}
